/** Shared helpers for annual "policy" rows (governance + social), aligned with GPolicyForm / EShareholder. */

export const hasUploadedDocument = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "string") {
    const cleaned = value.trim();
    if (!cleaned) return false;
    if (cleaned.toLowerCase() === "no documents available") return false;
    return true;
  }
  if (value && typeof value === "object") return Object.keys(value).length > 0;
  console.log("hasUploadedDocument",Boolean(value))
  return Boolean(value);
};

/** YYYY-MM-DD bounds for effective date: allow from 2021 onward; cap max by reporting year/today. */
export const getEffectiveDateMinMax = (reportingYear) => {
  if (!Number.isFinite(Number(reportingYear)) || Number(reportingYear) <= 0)
    return { min: undefined, max: undefined };
  const y = Number(reportingYear);
  const pad = (n) => String(n).padStart(2, "0");
  const min = "2021-01-01";
  const now = new Date();
  const currentYear = now.getFullYear();
  const max =
    y === currentYear
      ? `${currentYear}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      : `${y}-12-31`;
  return { min, max };
};

/**
 * When annual policy status is Yes: errors for document and effectiveDate
 * depending on whether "Is the Policy revised?" is shown and on isRevised.
 */
export const annualPolicyYesFieldErrors = (policy, reportingYear, showIsRevisedBlock) => {
  const errors = {};
  const { min: effMin, max: effMax } = getEffectiveDateMinMax(Number(reportingYear));

  const addMandatory = () => {
    if (!hasUploadedDocument(policy?.documentUrl)) {
      errors.documentUrl = "File upload is mandatory.";
    }
    if (!policy?.effectiveDate) {
      errors.effectiveDate = "Effective date is mandatory.";
    } else if (
      effMin &&
      effMax &&
      (policy.effectiveDate < effMin || policy.effectiveDate > effMax)
    ) {
      errors.effectiveDate = `Effective date must be within the reporting year (${effMin} to ${effMax}).`;
    }
  };

  if (!showIsRevisedBlock) {
    addMandatory();
  } else if (policy?.isRevised) {
    addMandatory();
  } else if (
    policy?.effectiveDate &&
    effMin &&
    effMax &&
    (policy.effectiveDate < effMin || policy.effectiveDate > effMax)
  ) {
    errors.effectiveDate = `Effective date must be within the reporting year (${effMin} to ${effMax}).`;
  }
  return errors;
};

export const shouldShowAnnualPolicyRevised = (isFirstEntry, previousYearDocumentUrl) =>
  isFirstEntry && hasUploadedDocument(previousYearDocumentUrl);

export const isAnnualPolicyUploadDisabled = (isFirstEntry, previousYearDocumentUrl) =>
  !shouldShowAnnualPolicyRevised(isFirstEntry, previousYearDocumentUrl);
